/*eslint-disable */
import toast from '@/services/toast'; 
import {bus} from '@/main';  
export default {
  name: 'demo-req-remove-popup',
  components: {},
  props: ['demoReqID'],
  data () {
    return {
      submitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    closeDemoRequestInfoPopup() {
      bus.$emit('removeReqDemoPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    demoForRequestSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            id:this.demoReqID
          }
          this.$store.dispatch('deleteDemoRequestByIdAction', data)
            .then((res) => {  
              this.closeDemoRequestInfoPopup();
              this.$store.dispatch('getAllDemoRequestListAction')
              toast.success(res.data.msg || 'Reuest Demo deleted successfully');
              this.submitted =  false;
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },

  }
}